// extracted by mini-css-extract-plugin
export var richText = "rich-text-module--rich-text--ccf30";